import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { splitVariableArguments } from "@/input/utils/variableArguments";
import { twMerge } from "@/utils/twMerge";

import type { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

type Props = {
  node: VariableNodeModel;
  className?: string;
};

export const SplitArguments = observer(function SplitArguments({ node, className }: Props) {
  const t = useTranslations();

  const handleClick = () => {
    splitVariableArguments(node);
  };

  return (
    <Sidebar.Button
      title={t("sidebar.actions.splitArguments")}
      icon={<Icon name="math/SplitArguments" />}
      onClick={handleClick}
      className={twMerge("flex-shrink-0 min-h-full h-[28px]", className)}
      inverted
    />
  );
});
